
// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Card,
//   CardMedia,
//   CardContent,
//   Typography,
//   Button,
//   useMediaQuery,
//   CircularProgress
// } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import { Link, useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';

// // Import all Material UI icons we might need for amenities
// import BedIcon from '@mui/icons-material/Bed';
// import BathtubIcon from '@mui/icons-material/Bathtub';
// import SquareFootIcon from '@mui/icons-material/SquareFoot';
// import ApartmentIcon from '@mui/icons-material/Apartment';
// import ElevatorIcon from '@mui/icons-material/Elevator';
// import LocalParkingIcon from '@mui/icons-material/LocalParking';
// import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
// import PoolIcon from '@mui/icons-material/Pool';
// import PetsIcon from '@mui/icons-material/Pets';
// import AcUnitIcon from '@mui/icons-material/AcUnit';
// import TvIcon from '@mui/icons-material/Tv';
// import ChairIcon from '@mui/icons-material/Chair';
// import KitchenIcon from '@mui/icons-material/Kitchen';
// import WeekendIcon from '@mui/icons-material/Weekend';
// import WifiIcon from '@mui/icons-material/Wifi';
// import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
// import MicrowaveIcon from '@mui/icons-material/Microwave';
// import PowerIcon from '@mui/icons-material/Power';

// // Function to get the appropriate icon based on amenity type
// const getAmenityIcon = (amenityType) => {
//   const amenityIconMap = {
//     'BHK': <BedIcon />,
//     'Floor': <ApartmentIcon />,
//     'Size': <SquareFootIcon />,
//     'Lift': <ElevatorIcon />,
//     'Parking': <LocalParkingIcon />,
//     'Gym': <FitnessCenterIcon />,
//     'Swimming Pool': <PoolIcon />,
//     'Pet Allowed': <PetsIcon />,
//     'AC': <AcUnitIcon />,
//     'TV': <TvIcon />,
//     'Sofa': <ChairIcon />,
//     'Fridge': <KitchenIcon />,
//     'Furnished': <WeekendIcon />,
//     'Internet': <WifiIcon />,
//     'Washing Machine': <LocalLaundryServiceIcon />,
//     'Microwave': <MicrowaveIcon />,
//     'Power Backup': <PowerIcon />,
//     'Bathroom': <BathtubIcon />
//   };
  
//   return amenityIconMap[amenityType] || <SquareFootIcon />;
// };

// const FeaturedProperties = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const navigate = useNavigate();
  
//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
  
//   const isLoggedIn = useSelector(state => state.user.isAuthenticated);
//   const userData = useSelector(state => state.user.user);

//   useEffect(() => {
//     const fetchCommercialProperties = async () => {
//       try {
//         const response = await fetch('https://www.propertydealstalk.com/api/property/filterProperties?property_type=commercial');
        
//         if (!response.ok) {
//           throw new Error('Failed to fetch properties');
//         }
        
//         const data = await response.json();
        
//         if (data.statusCode === 200) {
//           setProperties(data.result.properties);
//         } else {
//           throw new Error(data.message || 'Failed to fetch properties');
//         }
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCommercialProperties();
//   }, []);

//   const recordPropertyView = async (propertyId) => {
//     if (!isLoggedIn || !userData) {
//       console.log('User not logged in, skipping view recording');
//       return;
//     }

//     try {
//       const userId = userData.id;
      
//       if (!userId) {
//         console.error('User ID not found in user data');
//         return;
//       }

//       console.log('Recording property view with user_id:', userId, 'property_id:', propertyId);

//       const response = await fetch('https://propertydealstalk.com/api/buyer/recordPropertyView', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           user_id: userId,
//           property_id: propertyId
//         }),
//       });

//       const data = await response.json();
      
//       if (data.statusCode === 200) {
//         console.log('Property view recorded successfully:', data.result);
//       } else {
//         console.error('Failed to record property view:', data.message);
//       }
//     } catch (err) {
//       console.error('Error recording property view:', err);
//     }
//   };

//   const formatPrice = (price) => {
//     if (!price) return '';
//     return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//   };

//   // ✅ Updated function to check if image has valid data
//   const hasValidImage = (base64) => {
//     return base64 && base64.length > 100;
//   };

//   const handleViewAllClick = () => {
//     navigate('/featured-view');
//   };

//   const handleViewProperty = (propertyId) => {
//     recordPropertyView(propertyId);
//   };

//   // ✅ UPDATED: Function to check if a value is valid (not null, undefined, 'N/A', or empty)
//   const isValidValue = (value) => {
//     return value && value !== 'N/A' && value !== 'null' && value !== null && value !== undefined && value.toString().trim() !== '';
//   };

//   // ✅ UPDATED: Get only valid property amenities
//   const getPropertyAmenities = (property) => {
//     const amenities = [];
    
//     // Check BHK
//     if (isValidValue(property.bhk)) {
//       amenities.push({ type: 'BHK', value: `${property.bhk} BHK` });
//     }
    
//     // Check Floor - only add if both select_floor and total_floors are valid
//     if (isValidValue(property.select_floor) && isValidValue(property.total_floors)) {
//       amenities.push({ type: 'Floor', value: `${property.select_floor}/${property.total_floors} Floor` });
//     }
    
//     // Check Size
//     if (isValidValue(property.property_size)) {
//       const sizeUnit = isValidValue(property.property_size_units) ? property.property_size_units : 'sq.ft';
//       amenities.push({ type: 'Size', value: `${property.property_size} ${sizeUnit}` });
//     }
    
//     return amenities;
//   };

//   return (
//     <Box
//       id="featured-properties"
//       sx={{
//         backgroundColor: '#fff',
//         padding: '0 20px 40px',
//         display: 'flex',
//         flexDirection: 'column',
//         gap: '30px',
//         marginTop: '30px',
//         fontFamily: 'Outfit',
//       }}
//     >
//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           margin: '20px 0',
//           position: 'relative',
//         }}
//       >
//         <Box sx={{ width: '100%', textAlign: 'center' }}>
//           <Typography
//             sx={{
//               fontSize: '1.5rem',
//               fontWeight: 600,
//               position: 'absolute',
//               left: '50%',
//               transform: 'translateX(-50%)',
//               width: 'auto',
//             }}
//           >
//             Commercial Properties
//           </Typography>
//         </Box>
//         <Button
//           onClick={handleViewAllClick}
//           variant="text"
//           sx={{
//             color: '#626262',
//             fontSize:'0.8rem',
//             fontWeight: 500,
//             zIndex: 1,
//             marginLeft: 'auto',
//           }}
//         >
//           View All
//         </Button>
//       </Box>

//       {loading ? (
//         <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//           <CircularProgress />
//         </Box>
//       ) : error ? (
//         <Typography color="error" sx={{ textAlign: 'center' }}>
//           {error}
//         </Typography>
//       ) : (
//         <Box
//           sx={{
//             display: 'grid',
//             gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
//             gap: '20px',
//             alignItems: 'stretch',
//           }}
//         >
//           {properties.slice(0, 4).map((property, index) => {
//             const isResidential = property.property_type === 'residential';
//             const isReadyToMove = property.construction_status === 'ready to move';
//             const propertyAmenities = getPropertyAmenities(property);
//             const hasImage = hasValidImage(property.image);

//             return (
//               <Box
//                 key={property.id}
//                 sx={{
//                   width: '100%',
//                   display: 'flex',
//                   justifyContent: 'center',
//                 }}
//               >
//                 <Card
//                   sx={{
//                     width: { xs: '100%', sm: 360, md: '100%' },
//                     maxWidth: 350,
//                     height: '100%',
//                     backgroundColor: '#fff',
//                     borderRadius: '12px',
//                     boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
//                     overflow: 'hidden',
//                     transition: 'transform 0.3s ease',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     '&:hover': {
//                       transform: 'translateY(-5px)',
//                     },
//                   }}
//                 >
//                   <Box sx={{ position: 'relative', width: '100%', height: 200, overflow: 'hidden' }}>
//                     {hasImage ? (
//                       <CardMedia
//                         component="img"
//                         image={`data:image/png;base64,${property.image}`}
//                         alt={property.property_name}
//                         sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
//                       />
//                     ) : (
//                       <Box
//                         sx={{
//                           width: '100%',
//                           height: '100%',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           backgroundColor: '#f5f5f5',
//                           border: '1px dashed #ccc'
//                         }}
//                       >
//                         <Typography variant="body2" color="#888" textAlign="center" px={2}>
//                           No images uploaded
//                         </Typography>
//                       </Box>
//                     )}

//                     <Box
//                       sx={{
//                         position: 'absolute',
//                         bottom: 0,
//                         left: 0,
//                         display: 'flex',
//                         width: '100%',
//                         height: '36px',
//                         zIndex: 2,
//                         lineHeight: 1,
//                         fontSize: '13px',
//                         fontWeight: 600,
//                       }}
//                     >
//                       <Box
//                         sx={{
//                           backgroundColor: '#f7931e',
//                           color: '#fff',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           whiteSpace: 'nowrap',
//                           clipPath: 'polygon(0 0, 100% 0, 75% 100%, 0% 100%)',
//                           padding: '3px 50px 6px 16px',
//                           marginRight: '-30px',
//                           height: '100%',
//                         }}
//                       >
//                         {isResidential ? 'Residential' : 'Commercial'}
//                       </Box>
//                       <Box
//                         sx={{
//                           backgroundColor: isReadyToMove ? '#00a885' : '#004b8d',
//                           color: '#fff',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           whiteSpace: 'nowrap',
//                           clipPath: 'polygon(15% 0, 100% 0, 100% 100%, 0 100%)',
//                           padding: isReadyToMove ? '3px 46px 6px 80px' : '6px 46px 6px 60px',
//                           height: '100%',
//                         }}
//                       >
//                         {isReadyToMove ? 'Ready to Move' : 'Under Construction'}
//                       </Box>
//                     </Box>
//                   </Box>

//                   <CardContent
//                     sx={{
//                       padding: '15px',
//                       display: 'flex',
//                       flexDirection: 'column',
//                       gap: '10px',
//                       flexGrow: 1,
//                       width: '90% !important',
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'flex-start',
//                         gap: '10px',
//                         minHeight: '50px',
//                       }}
//                     >
//                       <Typography
//                         sx={{
//                           fontSize: '18px',
//                           fontWeight: 600,
//                           color: '#000',
//                           overflow: 'hidden',
//                           textOverflow: 'ellipsis',
//                           display: '-webkit-box',
//                           WebkitLineClamp: 2,
//                           WebkitBoxOrient: 'vertical',
//                           flex: 1,
//                         }}
//                       >
//                         {property.property_name}
//                       </Typography>
//                       {property.asking_price && (
//                         <Typography
//                           sx={{
//                             fontSize: '14px',
//                             color: '#2563EB',
//                             fontWeight: 300,
//                             whiteSpace: 'nowrap',
//                             alignSelf: 'flex-start',
//                           }}
//                         >
//                           ₹{formatPrice(property.asking_price)}
//                         </Typography>
//                       )}
//                     </Box>

//                     <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '14px', color: '#666', gap: '6px', minHeight: '24px' }}>
//                       <LocationOnIcon fontSize="small" sx={{ color: '#666' }} />
//                       <Typography
//                         sx={{
//                           overflow: 'hidden',
//                           textOverflow: 'ellipsis',
//                           whiteSpace: 'nowrap',
//                         }}
//                       >
//                         {property.location}, {property.area_name}
//                       </Typography>
//                     </Box>

//                     {/* ✅ UPDATED: Only render amenities box if there are valid amenities */}
//                     {propertyAmenities.length > 0 && (
//                       <Box
//                         sx={{
//                           display: 'flex',
//                           justifyContent: 'space-between',
//                           alignItems: 'center',
//                           width: '100%',
//                           minHeight: '70px',
//                           gap: '8px',
//                         }}
//                       >
//                         {propertyAmenities.map((amenity, idx) => (
//                           <Box
//                             key={idx}
//                             sx={{
//                               flex: 1,
//                               display: 'flex',
//                               flexDirection: 'column',
//                               alignItems: 'center',
//                               justifyContent: 'center',
//                               gap: '6px',
//                             }}
//                           >
//                             <Box sx={{ color: '#666', fontSize: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                               {getAmenityIcon(amenity.type)}
//                             </Box>
//                             <Typography
//                               sx={{
//                                 fontSize: '13px',
//                                 color: '#444',
//                                 textAlign: 'center',
//                                 lineHeight: 1.2,
//                               }}
//                             >
//                               {amenity.value}
//                             </Typography>
//                           </Box>
//                         ))}
//                       </Box>
//                     )}

//                     <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 'auto', pt: '10px' }}>
//                       <Button
//                         component={Link}
//                         to={`/view/${property.id}`}
//                         variant="contained"
//                         onClick={() => handleViewProperty(property.id)}
//                         sx={{
//                           padding: '10px 44px',
//                           backgroundColor: '#005eff',
//                           color: 'white',
//                           borderRadius: '6px',
//                           cursor: 'pointer',
//                           fontWeight: 500,
//                           width: { xs: '100%', sm: 'fit-content' },
//                           '&:hover': {
//                             backgroundColor: '#004ecb',
//                           },
//                         }}
//                       >
//                         View Property
//                       </Button>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               </Box>
//             );
//           })}
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default FeaturedProperties;


import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  useMediaQuery,
  CircularProgress
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Import all Material UI icons we might need for amenities
import BedIcon from '@mui/icons-material/Bed';
import BathtubIcon from '@mui/icons-material/Bathtub';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ElevatorIcon from '@mui/icons-material/Elevator';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import PoolIcon from '@mui/icons-material/Pool';
import PetsIcon from '@mui/icons-material/Pets';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import TvIcon from '@mui/icons-material/Tv';
import ChairIcon from '@mui/icons-material/Chair';
import KitchenIcon from '@mui/icons-material/Kitchen';
import WeekendIcon from '@mui/icons-material/Weekend';
import WifiIcon from '@mui/icons-material/Wifi';
import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
import MicrowaveIcon from '@mui/icons-material/Microwave';
import PowerIcon from '@mui/icons-material/Power';

// Function to get the appropriate icon based on amenity type
const getAmenityIcon = (amenityType) => {
  const amenityIconMap = {
    'BHK': <BedIcon />,
    'Floor': <ApartmentIcon />,
    'Size': <SquareFootIcon />,
    'Lift': <ElevatorIcon />,
    'Parking': <LocalParkingIcon />,
    'Gym': <FitnessCenterIcon />,
    'Swimming Pool': <PoolIcon />,
    'Pet Allowed': <PetsIcon />,
    'AC': <AcUnitIcon />,
    'TV': <TvIcon />,
    'Sofa': <ChairIcon />,
    'Fridge': <KitchenIcon />,
    'Furnished': <WeekendIcon />,
    'Internet': <WifiIcon />,
    'Washing Machine': <LocalLaundryServiceIcon />,
    'Microwave': <MicrowaveIcon />,
    'Power Backup': <PowerIcon />,
    'Bathroom': <BathtubIcon />
  };

  return amenityIconMap[amenityType] || <SquareFootIcon />;
};

const FeaturedProperties = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isLoggedIn = useSelector(state => state.user.isAuthenticated);
  const userData = useSelector(state => state.user.user);

  useEffect(() => {
    const fetchCommercialProperties = async () => {
      try {
        const response = await fetch('https://www.propertydealstalk.com/api/property/filterProperties?property_type=commercial');

        if (!response.ok) {
          throw new Error('Failed to fetch properties');
        }

        const data = await response.json();

        if (data.statusCode === 200) {
          setProperties(data.result.properties);
        } else {
          throw new Error(data.message || 'Failed to fetch properties');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCommercialProperties();
  }, []);

  const recordPropertyView = async (propertyId) => {
    if (!isLoggedIn || !userData) {
      console.log('User not logged in, skipping view recording');
      return;
    }

    try {
      const userId = userData.id;
      if (!userId) {
        console.error('User ID not found in user data');
        return;
      }

      console.log('Recording property view with user_id:', userId, 'property_id:', propertyId);

      const response = await fetch('https://propertydealstalk.com/api/buyer/recordPropertyView', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
          property_id: propertyId
        }),
      });

      const data = await response.json();
      if (data.statusCode === 200) {
        console.log('Property view recorded successfully:', data.result);
      } else {
        console.error('Failed to record property view:', data.message);
      }
    } catch (err) {
      console.error('Error recording property view:', err);
    }
  };

  // ✅ Format price with commas
  const formatPrice = (price) => {
    if (!price || price === 0 || price === '0') return '';
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // ✅ Updated function to check if image has valid data
  const hasValidImage = (base64) => {
    return base64 && base64.length > 100;
  };

  const handleViewAllClick = () => {
    navigate('/featured-view');
  };

  const handleViewProperty = (propertyId) => {
    recordPropertyView(propertyId);
  };

  // ✅ UPDATED: Function to check if a value is valid (not null, undefined, 'N/A', or empty)
  const isValidValue = (value) => {
    return value && value !== 'N/A' && value !== 'null' && value !== null && value !== undefined && value.toString().trim() !== '';
  };

  // ✅ FIXED: Function to get display price - matches TalkView.jsx logic
  const getDisplayPrice = (property) => {
    // Check if this is a rental property (case-insensitive comparison)
    const category = property.category || property.commercial_catgory || '';
    const isRental = category.toLowerCase() === 'rent';

    if (isRental) {
      // For rental properties, prioritize monthly_rent
      if (isValidValue(property.monthly_rent) && property.monthly_rent !== 0) {
        return property.monthly_rent;
      }
    }

    // For sale properties or if monthly_rent is not available, use asking_price
    if (isValidValue(property.asking_price) && property.asking_price !== 0) {
      return property.asking_price;
    }

    return null; // Return null if no price is available
  };

  // ✅ UPDATED: Get only valid property amenities
  const getPropertyAmenities = (property) => {
    const amenities = [];

    // Check BHK
    if (isValidValue(property.bhk)) {
      amenities.push({ type: 'BHK', value: `${property.bhk} BHK` });
    }

    // Check Floor - only add if both select_floor and total_floors are valid
    if (isValidValue(property.select_floor) && isValidValue(property.total_floors)) {
      amenities.push({ type: 'Floor', value: `${property.select_floor}/${property.total_floors} Floor` });
    }

    // Check Size
    if (isValidValue(property.property_size)) {
      const sizeUnit = isValidValue(property.property_size_units) ? property.property_size_units : 'sq.ft';
      amenities.push({ type: 'Size', value: `${property.property_size} ${sizeUnit}` });
    }

    return amenities;
  };

  return (
    <Box
      id="featured-properties"
      sx={{
        backgroundColor: '#fff',
        padding: '0 20px 40px',
        display: 'flex',
        flexDirection: 'column',
        gap: '30px',
        marginTop: '30px',
        fontFamily: 'Outfit',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          margin: '20px 0',
          position: 'relative',
        }}
      >
        <Box sx={{ width: '100%', textAlign: 'center' }}>
          <Typography
            sx={{
              fontSize: '1.5rem',
              fontWeight: 600,
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 'auto',
            }}
          >
            Commercial Properties
          </Typography>
        </Box>
        <Button
          onClick={handleViewAllClick}
          variant="text"
          sx={{
            color: '#626262',
            fontSize: '0.8rem',
            fontWeight: 500,
            zIndex: 1,
            marginLeft: 'auto',
          }}
        >
          View All
        </Button>
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography color="error" sx={{ textAlign: 'center' }}>
          {error}
        </Typography>
      ) : (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
            gap: '20px',
            alignItems: 'stretch',
          }}
        >
          {properties.slice(0, 4).map((property, index) => {
            const isResidential = property.property_type === 'residential';
            const isReadyToMove = property.construction_status === 'ready to move';
            const propertyAmenities = getPropertyAmenities(property);
            const hasImage = hasValidImage(property.image);
            const displayPrice = getDisplayPrice(property);
            const isRental = (property.category || property.commercial_catgory || '').toLowerCase() === 'rent';

            return (
              <Box
                key={property.id}
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Card
                  sx={{
                    width: { xs: '100%', sm: 360, md: '100%' },
                    maxWidth: 350,
                    height: '100%',
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                    transition: 'transform 0.3s ease',
                    display: 'flex',
                    flexDirection: 'column',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                    },
                  }}
                >
                  <Box sx={{ position: 'relative', width: '100%', height: 200, overflow: 'hidden' }}>
                    {hasImage ? (
                      <CardMedia
                        component="img"
                        image={`data:image/png;base64,${property.image}`}
                        alt={property.property_name}
                        sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#f5f5f5',
                          border: '1px dashed #ccc'
                        }}
                      >
                        <Typography variant="body2" color="#888" textAlign="center" px={2}>
                          No images uploaded
                        </Typography>
                      </Box>
                    )}

                    <Box
                      sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        display: 'flex',
                        width: '100%',
                        height: '36px',
                        zIndex: 2,
                        lineHeight: 1,
                        fontSize: '13px',
                        fontWeight: 600,
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: '#f7931e',
                          color: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          whiteSpace: 'nowrap',
                          clipPath: 'polygon(0 0, 100% 0, 75% 100%, 0% 100%)',
                          padding: '3px 50px 6px 16px',
                          marginRight: '-30px',
                          height: '100%',
                        }}
                      >
                        {isResidential ? 'Residential' : 'Commercial'}
                      </Box>
                      <Box
                        sx={{
                          backgroundColor: isReadyToMove ? '#00a885' : '#004b8d',
                          color: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          whiteSpace: 'nowrap',
                          clipPath: 'polygon(15% 0, 100% 0, 100% 100%, 0 100%)',
                          padding: isReadyToMove ? '3px 46px 6px 80px' : '6px 46px 6px 60px',
                          height: '100%',
                        }}
                      >
                        {isReadyToMove ? 'Ready to Move' : 'Under Construction'}
                      </Box>
                    </Box>
                  </Box>

                  <CardContent
                    sx={{
                      padding: '15px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px',
                      flexGrow: 1,
                      width: '90% !important',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        gap: '10px',
                        minHeight: '50px',
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: '18px',
                          fontWeight: 600,
                          color: '#000',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          flex: 1,
                        }}
                      >
                        {property.property_name}
                      </Typography>

                      {/* ✅ FIXED: Price display with proper logic */}
                      <Typography
                        sx={{
                          fontSize: '14px',
                          color: '#2563EB',
                          fontWeight: 300,
                          whiteSpace: 'nowrap',
                          alignSelf: 'flex-start',
                        }}
                      >
                        {displayPrice ? (
                          <>
                            ₹ {formatPrice(displayPrice)}
                            {isRental && '/month'}
                          </>
                        ) : (
                          'Price on Request'
                        )}
                      </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '14px', color: '#666', gap: '6px', minHeight: '24px' }}>
                      <LocationOnIcon fontSize="small" sx={{ color: '#666' }} />
                      <Typography
                        sx={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {property.location}, {property.area_name}
                      </Typography>
                    </Box>

                    {/* ✅ UPDATED: Only render amenities box if there are valid amenities */}
                    {propertyAmenities.length > 0 && (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%',
                          minHeight: '70px',
                          gap: '8px',
                        }}
                      >
                        {propertyAmenities.map((amenity, idx) => (
                          <Box
                            key={idx}
                            sx={{
                              flex: 1,
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px',
                            }}
                          >
                            <Box sx={{ color: '#666', fontSize: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              {getAmenityIcon(amenity.type)}
                            </Box>
                            <Typography
                              sx={{
                                fontSize: '13px',
                                color: '#444',
                                textAlign: 'center',
                                lineHeight: 1.2,
                              }}
                            >
                              {amenity.value}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    )}

                    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 'auto', pt: '10px' }}>
                      <Button
                        component={Link}
                        to={`/view/${property.id}`}
                        variant="contained"
                        onClick={() => handleViewProperty(property.id)}
                        sx={{
                          padding: '10px 44px',
                          backgroundColor: '#005eff',
                          color: 'white',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontWeight: 500,
                          width: { xs: '100%', sm: 'fit-content' },
                          '&:hover': {
                            backgroundColor: '#004ecb',
                          },
                        }}
                      >
                        View Property
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
};

export default FeaturedProperties;